import { theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { useTranslation } from 'react-i18next';
import LocationRow from 'screens/permit/permitRows/LocationRow';
import ParkingSpaceRow from 'screens/permit/permitRows/ParkingSpaceRow';
import TicketRow from 'screens/permit/permitRows/TicketRow';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import { makePoint } from 'utils/mapUtils';

const WaitingListPermit = ({
  permit,
  onPress,
}: {
  permit: UnifiedPermit;
  onPress?: () => void;
}) => {
  const { t } = useTranslation();

  const { id, orderLines, resolvedParkingSpaces } = permit;
  const pmc = orderLines?.find(Boolean)?.pmc;
  const { parkZone } = pmc ?? {};

  const marker = parkZone?.address?.marker;
  const markerCoordinate = marker ? makePoint(marker.coordinates) : undefined;
  const street = parkZone?.address?.street ?? t('parkingZone.noAddress');
  const number = parkZone?.address?.number || '';

  return (
    <>
      <LocationRow
        uid={id}
        street={street}
        number={number}
        markerCoordinate={markerCoordinate}
      />
      <TicketRow
        title={t('services.permitType')}
        content={t('permit.type.MONTHLY')}
      />
      <ParkingSpaceRow
        uid={id}
        parkingSpaces={resolvedParkingSpaces}
        pmc={pmc}
        permit={permit}
        orderLineIdWithVersion={permit.orderLineIdWithVersion}
      />
      <TicketRow
        title={t('services.billing')}
        content={t('services.recurringPayment')}
      />
      <TicketRow
        onPress={onPress}
        titleColor={theme.colors.black}
        title={t('services.viewDetails')}
        divider={false}>
        <Icon name="Chevron_Right" size="s" />
      </TicketRow>
    </>
  );
};
export default WaitingListPermit;
